import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceIssueArchivalRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-issue',
	path: '/jira/settings/system/performance/metrics/issue',
};
